export default __webpack_public_path__ + "static/media/think3.952bc2f3.png";